import React from 'react';
import { Checkbox } from './checkbox';

export const FitOptionsButtons = props => {
  const {
    value = 'contain',
    onChange,
    includeFixed = false,
    includeContent = false,
    fillLabel = 'Remplir la case',
  } = props;

  const options = [
    { key: 'cover', label: fillLabel },
    { key: 'stretch', label: 'Remplir (etire)' },
    { key: 'contain', label: 'Afficher en entier' },
  ];
  if (includeContent) {
    options.unshift({ key: 'content', label: 'Contenu visible' });
  }
  if (includeFixed) {
    options.push({ key: 'fixed', label: 'Continuite entre cases' });
  }

  return (
    <div className='flex gap-02 flex-wrap'>
      {options.map(option => {
        const isActive = value === option.key;
        return (
          <div
            key={option.key}
            className={`cursor-pointer text-xs font-semibold px-03 py-01 rounded transition ${
              isActive
                ? 'bg-primary text-main'
                : 'bg-main text-contrast text-opacity-70'
            }`}
            onClick={e => {
              e.stopPropagation();
              onChange?.(option.key);
            }}
          >
            {option.label}
          </div>
        );
      })}
    </div>
  );
};

export const MaskControls = props => {
  const {
    fit = 'contain',
    onFitChange,
    invert = false,
    onInvertChange,
    rotate = 0,
    onRotateChange,
    includeFixed = true,
    fillLabel = 'Remplir la case',
  } = props;

  return (
    <div className='flex flex-col gap-05'>
      <div className='text-xs text-contrast text-opacity-70'>
        Affichage du masque
      </div>
      <FitOptionsButtons
        value={fit}
        onChange={onFitChange}
        includeFixed={includeFixed}
        fillLabel={fillLabel}
      />
      <Checkbox
        label='Inverser le masque'
        value={invert === true}
        size='sm'
        onChange={next => onInvertChange?.(next)}
        className='text-xs text-contrast text-opacity-70'
      />
      <div className='flex gap-02 flex-wrap'>
        {[
          { key: 0, label: '0°' },
          { key: 90, label: '90°' },
          { key: -90, label: '-90°' },
          { key: 180, label: '180°' },
        ].map(option => {
          const isActive = (rotate ?? 0) === option.key;
          return (
            <div
              key={option.key}
              className={`cursor-pointer text-xs font-semibold px-03 py-01 rounded transition ${
                isActive
                  ? 'bg-primary text-main'
                  : 'bg-main text-contrast text-opacity-70'
              }`}
              onClick={e => {
                e.stopPropagation();
                onRotateChange?.(option.key);
              }}
            >
              {option.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};
